<template>
  <label :class="{ active: app.permissions[type] }">
    <input
      type="checkbox"
      :checked="app.permissions[type]"
      hidden
      @change="app.setGlobalPermission(type, ($event.target as HTMLInputElement).checked)"
    />
    <i class="bx" :class="!app.permissions[type] && icon2 ? icon2 : icon" />
  </label>
</template>

<script lang="ts" setup>
import { getApp } from '../models/App';
import type { Permissions } from '../types';

defineProps<{
  icon: string;
  icon2?: string;
  type: keyof Permissions;
}>();

const app = getApp();
</script>

<style scoped>
label {
  font-size: 20px;
  width: 32px;
  height: 32px;
  line-height: 28px;
  text-align: center;
  position: relative;
  color: var(--color-gray-light);
  cursor: pointer;
}

label.active {
  color: var(--color-black);
}

label::after {
  display: table;
  content: '';
  position: absolute;
  bottom: 0px;
  width: 100%;
  height: 4px;
  left: 0px;
  background: var(--color-gray-lighter);
}

label.active::after {
  background: var(--color-accent-selected-bar);
}

label:hover {
  outline: 1px solid black;
}
</style>
